import {
  FIXTURE_ACTION_TYPE,
  FIXTURE_END_MATCH_REASON,
  FixtureEndMatchReason,
} from '@/service/constants';
import { FixtureAction, FixtureConfig } from '@/service/types';

export const getActionSubTypeName = (
  actionSubTypeId: number | null,
  fixtureConfig: FixtureConfig | undefined,
  fixtureActionTypeId?: FixtureAction['fixtureActionTypeId'],
  metadata?: FixtureAction['metadata'],
) => {
  if (
    fixtureActionTypeId &&
    metadata &&
    fixtureActionTypeId === FIXTURE_ACTION_TYPE.END_FIXTURE
  ) {
    return FIXTURE_END_MATCH_REASON[metadata.reason as FixtureEndMatchReason];
  }

  if (
    !fixtureConfig ||
    !fixtureConfig.fixtureOptions.actionButtons ||
    !actionSubTypeId
  ) {
    return '';
  }

  const actionButton = fixtureConfig.fixtureOptions.actionButtons.find(
    (ab) =>
      ab.actionType.subTypes != null &&
      ab.actionType.subTypes.some((s) => s.id === actionSubTypeId),
  );
  if (actionButton) {
    return (
      actionButton.actionType?.subTypes?.find((s) => s.id === actionSubTypeId)
        ?.name ?? ''
    );
  }
  return '';
};
